<!--  -->
<template>
  <div class="main-app flex">
    <div class="flex-1 l">
      <header>
        <h1>产品服务</h1>
      </header>
      <div class="flex product">
        <div>
          <li>
            <div class="logo">
              <img src="../../images/wlwps.png" />
            </div>
            <span>
              ETC服务-自有车开票
            </span>
          </li>
          <li class="totas">
            一键开票，优先锁定，对账报表，发票整理
          </li>
          <div class="primary" @click="goETCZY">
            一键开票
          </div>
          <!-- <div
                        class="text"
                    >
                        查看演示视频<i class="el-icon-arrow-right" />
                    </div> -->
        </div>
        <div style="borderLeft:1px solid #F1F6FF;">
          <li>
            <div class="logo">
              <img src="../../images/etc1.png" />
            </div>
            <span>
              ETC服务-外协车开票
            </span>
          </li>
          <li class="totas">
            仅需一键批量上传运单，“秒”领ETC发票，
            <br />
            轻松抵进项税，正规更省钱！
          </li>
          <div class="primary" @click="goETC">
            立即开票
          </div>
          <!-- <div
                        class="text"
                        @click="videoOpen"
                    >
                        查看演示视频<i class="el-icon-arrow-right" />
                    </div> -->
        </div>
      </div>
    </div>
    <nf-confirm :show.sync="show">
      <div slot="content">
        <div class="titleHeader">
          <div class="left">
            <img src="../../images/lhv2DA.png" class="transform" />
            <span
              style="display:inline-block;transform: translate(0px,-10px);fontSize:16px;color:hsla(0, 0%, 40%, 1)"
            >
              |
            </span>
            <div
              style="display:inline-block;transform: translate(0px,-10px);fontSize:14px;marginLeft:8px;fontWeight:650"
            >
              企业实名认证
            </div>
          </div>
        </div>
        <div class="matter">
          <p class="titleP">
            亲爱的企业管理员您好：
          </p>
          <p class="titlep">
            您的企业尚未进行企业实名认证，请点击下方认证按钮，<b>3分钟立即认证</b>，即可使用全部功能。
          </p>
        </div>
      </div>
      <div slot="footer">
        <span v-throttle="2000" class="blue" @click="handleSaveBtnClick">
          立即认证
        </span>
        <span class="anout" @click="show = false">
          忽略
        </span>
      </div>
    </nf-confirm>
    <AgentSMS v-if="SMSDialogShow" :show="SMSDialogShow" @cancel="SMSDialogShow = false" />
  </div>
</template>

<script>
import { enterApp, getAgreementDetails } from '@/api/eSign';
import store from '@/store/index';
import AgentSMS from './agentSMS.vue';

export default {
  name: '',
  components: { AgentSMS },
  data() {
    return {
      show: false,
      SMSDialogShow: false,
    };
  },
  computed: {
    creator() {
      return store.state.creator;
    },
    admin() {
      return store.state.admin;
    },
    corpCertityStatus() {
      return store.state.corpCertityStatus;
    },
    userCertityStatus() {
      return store.state.userCertityStatus;
    },
    corporationInfo() {
      return store.state.corporationInfo;
    },
    agentSMSValidateStatus() {
      return store.state.agentSMSValidateStatus;
    },
  },
  watch: {
    corporationInfo: {
      handler(n) {
        store.commit('updateCorporationInfo', n);
      },
    },
  },
  methods: {
    // 外协车开票
    async goETC() {
      let { data } = await getAgreementDetails();
      if (data.etcwxAgreement && data.etcwxAgreement.status === 2) {
        if (
          data.etcwxAgreement.renewalStatus === 'NO_NEED' ||
          data.etcwxAgreement.renewalStatus === 'RENEWING'
        ) {
          // 备案成功/续约中  短信验证
          this.handleValidateAgentSMS();
        } else {
          // 去备案
          this.handleEnterApp('etcwx');
        }
      } else if (
        (data.etcwxAgreement && data.etcwxAgreement.status !== 2) ||
        !data.etcwxAgreement
      ) {
        if (this.admin && !this.corpCertityStatus) {
          this.show = true;
        } else if (!this.admin && !this.corpCertityStatus) {
          this.$message({
            message:
              '您的企业尚未完成实名认证，请联系管理员' +
              this.corporationInfo.administrator +
              ':' +
              this.corporationInfo.administratorPhone +
              '进行企业实名认证',
            type: 'warning',
            showClose: true,
          });
        } else {
          this.handleEnterApp('etcwx');
        }
      }
    },
    // 经办人短信验证
    async handleValidateAgentSMS() {
      try {
        await store.dispatch('getAgentSMSValidate');
        if (this.agentSMSValidateStatus === 2 || this.agentSMSValidateStatus === 3) {
          let title = '经办人短信还未验证，请前往验证!';
          if (this.agentSMSValidateStatus === 3) title = '经办人短信验证已过期，请重新前往验证!';
          this.$confirm(title, '提示', {
            confirmButtonText: '前往验证',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              this.SMSDialogShow = true;
            })
            .catch(() => {});
        } else if (this.agentSMSValidateStatus === 1 || this.agentSMSValidateStatus === 4) {
          this.handleEnterApp('etcwx');
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    // 自有车开票
    async goETCZY() {
      let { data } = await getAgreementDetails();
      if (data.etczyAgreement && data.etczyAgreement.status === 2) {
        this.handleEnterApp('etczy');
      } else if (
        (data.etczyAgreement && data.etczyAgreement.status !== 2) ||
        !data.etczyAgreement
      ) {
        if (this.admin && !this.corpCertityStatus) {
          this.show = true;
        } else if (!this.admin && !this.corpCertityStatus) {
          this.$message({
            message:
              '您的企业尚未完成实名认证，请联系管理员' +
              this.corporationInfo.administrator +
              ':' +
              this.corporationInfo.administratorPhone +
              '进行企业实名认证',
            type: 'warning',
            showClose: true,
          });
        } else {
          this.handleEnterApp('etczy');
        }
      }
    },
    // 页面跳转
    async handleEnterApp(appId) {
      try {
        const { code, data } = await enterApp({ appId });
        if (code === 200 && data) {
          window.open(data);
        }
      } catch (error) {
        return error;
      }
    },
    async handleSaveBtnClick() {
      if (this.creator) {
        window.open(window.location.origin + '/admin/location/index');
      } else {
        window.open(window.location.origin + '/admin/authentication/index');
      }
    },
    videoOpen() {
      this.$store.commit('upisopen', true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('./right.css');

.main-app {
  margin-bottom: 10px;
  .flex-1 {
    height: 274px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 0px 7px 0px rgba(214, 214, 214, 0.5);
    .product {
      height: 218px;
    }
    .product > div {
      flex: 1;
    }
    li {
      list-style-type: none;
      display: flex;
      margin: 35px 0 0 40px;
      height: 25px;
      .logo {
        display: inline-block;
        width: 30px;
        margin-right: 2px;
        cursor: zoom-in;
      }
      span {
        margin-left: 10px;
        font-size: 18px;
        font-weight: 600;
        color: rgba(24, 24, 24, 1);
        line-height: 25px;
        color: rgba(32, 44, 85, 1);
        height: 25px;
        display: inline-block;
      }
    }
    .totas {
      margin: 20px 0 0 40px;
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 22px;
    }
    .primary {
      display: inline-block;
      margin: 45px 25px 0 40px;
      width: 98px;
      height: 35px;
      background: rgba(33, 84, 189, 1);
      border-radius: 4px;
      line-height: 35px;
      font-size: 14px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      cursor: pointer;
      border: none;
    }
    .primary:hover {
      background: rgba(33, 84, 189, 0.8);
    }
    .text {
      display: inline-block;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      height: 20px;
      line-height: 35px;
      border: none;
      color: rgba(33, 84, 189, 1);
      .el-icon-arrow-right {
        margin-left: 5px;
        font-size: 8px;
      }
    }
    .text:hover {
      color: rgba(33, 84, 189, 0.8);
    }
  }
}
.transform {
  display: inline-block;
  width: 20% !important;
  margin: 0px 10px 0 20px;
}
.matter {
  // border-bottom: 1px solid hsla(233, 13%, 86%, 1);
  // border-top: 1px solid hsla(233, 13%, 86%, 1);
  margin-top: 10px;
  padding: 50px 30px 50px 40px;
}
.titleP {
  font-weight: 650;
  color: rgba(0, 0, 0, 0.647058823529412);
  font-size: 16px;
  line-height: 40px;
}
.titlep {
  font-size: 15px;
  line-height: 29px;
  text-indent: 30px;
  color: rgba(0, 0, 0, 0.647058823529412);
  b {
    color: hsla(221, 71%, 44%, 1);
    cursor: zoom-in;
    // cursor: pointer;
  }
}

.el-dialog__body {
  padding: 0 !important;
}
.el-dialog__footer {
  margin: 0 auto;
  span {
    display: inline-block;
    padding: 10px 30px;
    text-align: center;
    border-radius: 4px;
    color: #fff;
    background: #409eff;
    cursor: pointer;
  }
  .anout {
    color: #666;
    background: #fff;
    margin-left: 30px;
    box-sizing: border-box;
    border: 1px solid rgba(216, 217, 225, 1);
  }
  .blue {
    background: hsla(221, 71%, 44%, 1);
  }
}
.nf-confirm[data-v-6fa96304] {
  .el-dialog__body {
    padding-left: 0 !important;
  }
}

@media screen and (max-width: 1910px) {
  .content {
    span {
      width: 110px;
    }
  }
  .main-app {
    display: block;
    .l {
      margin: 0;
    }
  }
}
@media screen and (max-width: 1679px) {
  .content {
    span {
      width: 150px;
    }
  }
  .main-app {
    display: block;
    .l {
      margin: 0;
    }
  }
}
</style>
